
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","data-name":"Layer 4","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.5 14.69l4.95-4.74a7.503 7.503 0 00-9.13-5.4 7.446 7.446 0 00-4.4 3.14c.08 0 8.58 7 8.58 7z"}}),_c('path',{attrs:{"d":"M9.15 8.58c-.95-.59-2.04-.9-3.15-.89h-.08a5.997 5.997 0 00-4.84 9.43l7.42-.93 5.69-4.59-5.04-3.02zM19.45 9.95c-.11 0-.22-.01-.33-.01-.66 0-1.32.14-1.93.4s-3 1.26-3 1.26l3.31 4.09 5.92 1.44a4.866 4.866 0 00-3.96-7.17z"}}),_c('path',{attrs:{"d":"M1.08 17.12A5.996 5.996 0 006 19.69h13.12c1.79 0 3.44-.98 4.29-2.56l-9.23-5.53-13.1 5.52z"}})])
          )
        }
      }
    